'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _security = require('./_security.module');

var _security2 = _interopRequireDefault(_security);

require('./authService.provider');

require('./claimsAuthorize.directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import './unauthenticated';
//import './unauthorized';
//import './unauthorizedInterceptor';

//import './_security.init';
//import './_security.routes';
//import './authorizeInterceptor';
exports.default = _security2.default.name;


//////////////////
// WEBPACK FOOTER
// ./blocks/security/_index.js
// module id = 166
// module chunks = 0